import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function MicOffIcon(props, ref) {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "M8 8v-.006l2 2V10l3.414 3.414.003-.003 1.414 1.415-.002.002 1.414 1.415.003-.003 1.414 1.414-.003.003L20.5 20.5a1 1 0 0 1-1.414 1.414l-3.022-3.022A7.95 7.95 0 0 1 13 19.938V21a1 1 0 1 1-2 0v-1.062A8 8 0 0 1 4 12a1 1 0 1 1 2 0 6 6 0 0 0 8.587 5.415l-1.55-1.55A4.005 4.005 0 0 1 8 12v-1.172L2.086 4.914A1 1 0 0 1 3.5 3.5z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14 6v5.166l1.866 1.866q.132-.496.134-1.032V6a4 4 0 0 0-7.928-.762L10 7.166V6a2 2 0 1 1 4 0m3.417 8.583 1.477 1.477A7.96 7.96 0 0 0 20 12a1 1 0 1 0-2 0c0 .925-.21 1.8-.583 2.583"
    })]
  });
}
;
MicOffIcon.displayName = "MicOffIcon";
export default forwardRef(MicOffIcon);